import '../../App.css'
import { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid'
import { SelectGenericFromTable } from '../universal/Axios';
import { observer } from "mobx-react"
import Button from '@mui/material/Button'
import ArrowForward from '@mui/icons-material/ArrowForward';


const DensityNetworkConfigTable = observer(({ parent_id, selectDensityNetworkConfig, selectedDensityNetworkConfig }) => {
    const [densityNetworkConfigResultsData, setDensityNetworkConfigResultsData] = useState(undefined);
    const useAll = parent_id === "all";

    useEffect(() => {
        if (parent_id === undefined) {
            SelectGenericFromTable("select dnc1.*, dnc2.id as first_child_id from density_network_config dnc1 left join density_network_config dnc2 on dnc1.id = dnc2.parent_id where dnc1.parent_id is null and dnc1.is_gen_alg_generated = 0;", setDensityNetworkConfigResultsData)
        }
        else if (useAll) {
            SelectGenericFromTable("select * from density_network_config where is_gen_alg_generated = 0;", setDensityNetworkConfigResultsData)
        }
        else {
            SelectGenericFromTable("select * from density_network_config where parent_id = '" + parent_id + "' and is_gen_alg_generated = 0;", setDensityNetworkConfigResultsData)
        }
    }, []);

    const densityNetworkConfigResultsColumns = [
        {
            field: 'id',
            headerName: 'Density Network Config ID',
            width: 840,
            renderCell: (params) => (
                <>

                    {params.row.has_adjustment_networks &&
                        <a
                            href={'edit-density-network-config?id=' + params.row.id}
                        >
                            {params.row.id}
                        </a>
                    }
                </>
            ),
        },
        {
            headerName: 'Adjustments',
            field: 'has_adjustment_networks',
            width: 100,
        },
        {
            field: 'description',
            headerName: 'Description',
            width: 140,
        },
        {
            field: 'parent_id',
            headerName: 'Parent ID',
            width: 180,
        },
        {
            field: 'created_date',
            headerName: 'Created Date',
            width: 160
        }
    ];

    let densityNetworkConfigResultsDataRows = densityNetworkConfigResultsData?.filter(data => data != null).map((densityNetworkConfigResults) =>
    ({   
        id: densityNetworkConfigResults.id,
        description: densityNetworkConfigResults.description,
        parent_id: densityNetworkConfigResults.parent_id,
        created_date: densityNetworkConfigResults.created_date,
        has_adjustment_networks: densityNetworkConfigResults.first_child_id != undefined ? "Yes" : "No"
    }))


    if (densityNetworkConfigResultsData === undefined) {
        return (<p>loading...</p>)
    }
    return (
            <DataGrid
                disableSelectionOnClick
                rows={densityNetworkConfigResultsDataRows}
                columns={densityNetworkConfigResultsColumns}
                pagination={true}
                checkboxSelection={useAll}
                onSelectionModelChange={(selectedBaselineAudiences) => {
                    selectDensityNetworkConfig(selectedBaselineAudiences);
                }}
                selectionModel={selectedDensityNetworkConfig}
                initialState={{
                    sorting: {
                        sortModel: [{ field: 'has_adjustment_networks', sort: 'desc' }, { field: 'created_date', sort: 'desc' }],
                    },
                }}
            />
    )
});

export { DensityNetworkConfigTable };
